<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListCarteiras";

export default {
  data() {
    return {
      subjectPermission: "Carteiras",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
